import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';

// One zod instance with the OpenAPI extension (.openapi()), shared by server and web app.
extendZodWithOpenApi(z);

export { z };
